import { createFileRoute } from "@tanstack/react-router";

import { MeetPage } from "@/features/meet/room/meet-page";

export const Route = createFileRoute("/(meet)/meet/$roomName")({
  component: MeetRoomRoute,
});

function MeetRoomRoute() {
  const { roomName } = Route.useParams();
  return <MeetPage roomName={roomName} />;
}
